import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as l, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconUnread",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--unread"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Unread",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      d: "M1 3.5A1.5 1.5 0 0 1 2.5 2H6a.5.5 0 0 1 0 1H2.5a.5.5 0 0 0-.5.5v6.793l1.147-1.147.076-.062A.5.5 0 0 1 3.5 9h6a.5.5 0 0 0 .5-.5V6.75a.5.5 0 0 1 1 0V8.5A1.5 1.5 0 0 1 9.5 10H3.707l-1.853 1.854A.5.5 0 0 1 1 11.5v-8Zm8.314.25a.063.063 0 1 0-.127 0 .063.063 0 0 0 .127 0Zm1.686 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const g = /* @__PURE__ */ o(c, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=unread.js.map
